import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Loader } from '../../../../common/elements';
import { CategoryList } from './elements/CategoryList';
import { getCategories } from '../../../../../actions/forums/forums';
import ThemePageBanner from '../../../../dashboardNew/components/ThemePageBanner';
import { forumPageHelper } from '../../../../../helpers/prismicHelpers/prismic-custom-helpers/ForumPageHelper';
import { PrismicDocumentHelper } from '../../../../../helpers/prismicHelpers/PrismicHelpers';

class Categories extends Component {
    state = {
        forumInfo: ''
    }

    componentDidMount() {
        const { location, getCategories } = this.props,
            page = location.query && location.query.page ? location.query.page : 1;
        getCategories(11, page ? page : 1);
        this.getForumInfo();
    };

    getNextCategories(page) {
        const { getCategories } = this.props;
        getCategories(11, page ? page : 11);
        browserHistory.push(`/forums?page=${page}`);
    };

    async getForumInfo(){
        const data = await PrismicDocumentHelper('document.type', 'forum-page', false, 'at');
        const forumInfo = forumPageHelper(data);
        this.setState({ forumInfo })
         
    }
    render() {

        const { categories } = this.props;
        const forum = this.state.forumInfo[0];

        if (!categories) {
            return <Loader />;
        }

        return (
            <article className="forum-body theme-page-content-wrapper">
            {forum && <ThemePageBanner image='/images/forum-header.jpg' heading={forum.forum_title} />}
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 heading-section no-margin'>
                        {forum && <p className='body-copy'>{forum.forum_summary}</p>}
                        </div>
                        <main className="container">
                            <CategoryList categories={categories} />
                        </main>
                    </div>
                </div>
            </article>
        );
    };
}

Categories.propTypes = {
    location: PropTypes.object,
    categories: PropTypes.array,
    getCategories: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        categories: state.forums.categories
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCategories: (product_id, page) => dispatch(getCategories(product_id, page)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Categories);



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/Categories.js